module.exports = __webpack_public_path__ + "img/youye-1.png";